import styled from 'styled-components';

import { ContainerProps } from './types';

export const TextWithArrowButtonRoot = styled.button<ContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.token('text-default')};
  background-color: transparent;
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.normal};
  font-family: ${Styles.fontFamily.body};
  text-decoration: none;
  text-align: start;
  border: none;
  border-block-end: ${({ withBorder }) => (withBorder ? '1px solid rgba(0,0,0,0.1)' : 'none')};
  cursor: pointer;
`;

export const Label = styled.span`
  flex: 1;
`;
